import CoinManager, {CoinOptions} from "@/app/_components/Coin/CoinManager";
import {SRewardUIPresenter} from "@/app/_components/Coin/SRewardUIPresenter";
import { ReactPortal } from "react";
import {DriveUtil} from "@/Master/DriveUtil";
import {RewardType} from "@/Core/Reward/RewardInfo";
import UserGlobalMgr from "@/Core/UserGlobalMgr";

export class SRewardAnimation {

    static _isInit: boolean = false;
    private static effectPanel: HTMLElement | null;
    private static coinManager: CoinManager;
    private static targetNode: HTMLElement;
    private static iconNode: HTMLElement;
    private static textNode: HTMLElement;

    static Init(targetRef: HTMLElement, icon: HTMLElement, text: HTMLElement) {
        // if (this._isInit) return;
        this.targetNode = targetRef;
        this.iconNode = icon;
        this.textNode = text;
        // this._isInit = true;
        this.checkInitCoin();
    }

    static checkInitCoin(){
        if (!this.coinManager){
            this.coinManager = new CoinManager();
        }

        if (!this.effectPanel){
            this.effectPanel = document.getElementById('effectPanel');
            if (!this.effectPanel) {
                throw new Error(`Container with id not found.`);
            }
        }
    }


    static PlayFlyIcon(rewardType: RewardType, delta: number, complete: () => void, startPos: any = null, endPos: any = null)
    {
        if (delta <= 0) return;

        const count = 20;
        let toCount = 0;
        if (rewardType == RewardType.GC) toCount = SRewardUIPresenter.gcCount;
        if (rewardType == RewardType.SC) toCount = SRewardUIPresenter.scCountAtom;

        const startCount = (toCount - delta);
        const singleCount = (toCount - startCount) / 20;

        this.checkInitCoin();
        this.UpdateRewardLabelText(rewardType, startCount);
        if (this.effectPanel) {
            this.coinManager.createCoins(rewardType, count, this.iconNode, (index)=>{
                this.UpdateRewardLabelText(rewardType, startCount + singleCount * (index + 1));
                // console.log('PlayFlyIcon', index);
                if (index == count-1){
                    if (rewardType == RewardType.GC)
                    {
                        SRewardUIPresenter.Instance.UpdateGcCount();
                    }
                    if (rewardType == RewardType.SC)
                    {
                        SRewardUIPresenter.Instance.UpdateScCount();
                    }
                }
            });
        }
    }

    static PlayNumberRoll(rewardType: RewardType, delta: number, complete: () => void)
    {

    }

    public static UpdateRewardLabelText(type: RewardType, val: number) {
        switch (type) {
            case RewardType.GC:
                const curGcText = DriveUtil.ToGcString(val, true);
                console.log('UpdateRewardLabelText',type,curGcText);
                // this.textNode.innerText = curGcText;
                break;
            case RewardType.SC:
                // this.textNode.innerText = `${DriveUtil.ToNormalUnit(val)}`
                console.log('UpdateRewardLabelText',type,val);
                break;
            default:
                break;
        }
    }

}